import { MEMBER_PLAN, planFromUserType } from "../../utils/memberPlan";

/**
 * The member's plan: the permissions list first (refreshed after purchases),
 * then the cached profile (survives a cold start), then the subscription type
 * for backends without `plan`.
 */
export const selectMemberPlan = (state) => {
  const fromPermissions = state?.permissions?.plan;
  if (fromPermissions) return fromPermissions;

  const subscriber = state?.user?.master_club_subscriber;
  const fromProfile = subscriber?.access_info?.plan;
  if (fromProfile) return fromProfile;

  const type = subscriber?.subscription?.subscription_type?.name;
  return type ? planFromUserType(String(type).toLowerCase()) : MEMBER_PLAN.GUEST;
};

export const selectIsPremiumLite = (state) =>
  selectMemberPlan(state) === MEMBER_PLAN.PREMIUM_LITE;
